module.exports = __webpack_public_path__ + "static/media/foundation-for-science-and-technology.503b2f80.png";